import * as Yup from 'yup';

export const Schema = Yup.object().shape({
  consent: Yup.boolean().required(
    'Check the box to confirm before continuing.'
  ),
});
